import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function manageTeamBehaviourReducer(state = initialstate.manageTeamBehaviour, action) {
	switch (action.type) {
		case types.SET_EXTERNAL_TAB_VISIBLE: {
			let newState = {...state};
			newState.externalTabVisibile = action.externalTabVisibile;
			return newState;
		}
		case types.SET_PRIOR_PERIOD_BUTTON_VISIBLE: {
			let newState = {...state};
			newState.priorPeriodButtonVisible = action.priorPeriodButtonVisible;
			return newState;
		}
		case types.SET_MANAGE_TEAM_MAIN_HEADER_TEXT: {
			let newState = {...state};
			newState.mainHeaderText = action.mainHeaderText;
			return newState;
		}
		case types.SET_STATUS_COL_VISIBLE: {
			let newState = {...state};
			newState.statusColVisible = action.statusColVisible;
			return newState;
		}
		case types.SET_INDEPENDANCE_COL_VISIBLE: {
			let newState = {...state};
			newState.independanceColVisible = action.independanceColVisible;
			return newState;
		}
		case types.SET_ACTIONS_COL_VISIBLE: {
			let newState = {...state};
			newState.actionsColVisible = action.actionsColVisible;
			return newState;
		}
		case types.SET_POST_ARCHIVE_COL_VISIBLE: {
			let newState = {...state};
			newState.postArchiveColVisible = action.postArchiveColVisible;
			return newState;
		}
		case types.SET_ADD_EDIT_MODAL_TEXTS: {
			let newState = {...state};
			let newAddEditModalTexts = {...action.addEditModalTexts};
			newState.addEditModalTexts = newAddEditModalTexts;
			return newState;
		}
		case types.SET_ADD_THIRD_PARTY_MEMBER_BUTTON_VISIBLE: {
			let newState = {...state};
			newState.addThirdPartyMemberButtonVisible = action.addThirdPartyMemberButtonVisible;
			return newState;
		}
		case types.SET_SHOULD_CALL_VALIDATION: {
			let newState = {...state};
			newState.shouldCallValidations = action.shouldCallValidations;
			return newState;
		}

		default:
			return state;
	}
}
